import { ApiKeySecretResponse, RotateApiKeyRequest } from './types';
import { axiosMeedioClient } from '../client';

export const rotateApiKey = async (
  workspaceId: string,
  keyId: string,
  payload?: RotateApiKeyRequest
): Promise<ApiKeySecretResponse> => {
  const { data } = await axiosMeedioClient.post<ApiKeySecretResponse>(
    `/v1/workspaces/${workspaceId}/api-keys/${keyId}/rotate`,
    payload ?? {}
  );
  return data;
};
